import React from 'react';

import type { RouteObject } from 'react-router-dom';

import Pages from '@/pages';

import { UserPermissions } from '@components/Permissions/userPermission';

import { MeteringPointsChildrenPath } from '../MeteringPointDetails/routes';

const CommercialMeteringPointInformation = React.lazy(
  () => import('@/pages/CommercialMeteringPointDetails/views/Information'),
);
const CommercialMeteringPointEquipment = React.lazy(
  () =>
    import('@/pages/CommercialMeteringPointDetails/views/GasConsumingEquipment'),
);
const MeteringModemDetails = React.lazy(
  () => import('@/forms/MeteringModemForm'),
);
const MeteringDeviceDetails = React.lazy(
  () => import('@/forms/MeteringDeviceForm/MeteringDeviceFormPreviewMode'),
);

const CommercialMeteringPointNodes = React.lazy(() => import('@/pages/Nodes'));

const MeteringNodeInformation = React.lazy(
  () => import('@/pages/NodeDetails/views/Information'),
);
const MeteringDevices = React.lazy(() => import('@/pages/Devices'));

const MeteringNodeSeal = React.lazy(() => import('@/pages/Seal'));
const SealDetails = React.lazy(() => import('@/forms/MeteringNodeSealForm'));

const GasConsumingEquipmentFormView = React.lazy(
  () => import('@/pages/CommercialMeteringPointDetails/views/Form'),
);
const GasPipelines = React.lazy(
  () => import('@/pages/CommercialMeteringPointDetails/views/GasPipelines'),
);

const DocumentsAndActs = React.lazy(
  () => import('@/pages/CommercialMeteringPointDetails/views/DocumentsAndActs'),
);

export const commercialMeteringPointsNodeRoutes: RouteObject[] = [
  {
    index: true,
    element: <MeteringNodeInformation />,
  },
  {
    path: Pages.DEVICES,
    element: <MeteringDevices />,
    children: [
      {
        path: MeteringPointsChildrenPath.MODEMS + '/:modemId',
        element: <MeteringModemDetails />,
      },
      {
        path: ':deviceId',
        element: <MeteringDeviceDetails />,
      },
    ],
  },
  {
    path: `${Pages.EQUIPMENT}`,
    element: <CommercialMeteringPointEquipment />,
    children: [
      {
        path: ':gasConsumingEquipmentId',
        element: <GasConsumingEquipmentFormView />,
      },
    ],
  },
];

export const commercialMeteringPointDetailsRoutes: RouteObject[] = [
  {
    element: <CommercialMeteringPointInformation />,
    index: true,
  },
  {
    path: `${Pages.EQUIPMENT}`,
    element: <CommercialMeteringPointEquipment />,
    children: [
      {
        path: ':gasConsumingEquipmentId',
        element: <GasConsumingEquipmentFormView />,
      },
    ],
    handle: {
      permissions: UserPermissions.CommercialConsumersGasConsumingEquipmentRead,
    },
  },
  {
    path: Pages.SEALS,
    element: <MeteringNodeSeal />,
    children: [{ path: ':sealId', element: <SealDetails /> }],
    handle: {
      permissions: UserPermissions.CommercialConsumersSealRead,
    },
  },
  {
    path: Pages.GAS_PIPELINES,
    element: <GasPipelines />,
    handle: {
      permissions: UserPermissions.CommercialConsumersGasPipelineSectionRead,
    },
  },
  {
    path: Pages.DEVICES,
    element: <MeteringDevices />,
    children: [
      {
        path: Pages.MODEMS + '/:modemId',
        element: <MeteringModemDetails />,
      },
      {
        path: ':deviceId',
        element: <MeteringDeviceDetails />,
      },
    ],
    handle: {
      permissions: UserPermissions.CommercialConsumersMeteringDeviceRead,
    },
  },
  {
    path: `${Pages.METERING_NODES}`,
    element: <CommercialMeteringPointNodes />,
    handle: {
      permissions: UserPermissions.CommercialConsumersGasMeteringNodeRead,
    },
  },
  {
    path: `${Pages.DOCUMENTS_AND_ACTS}`,
    element: <DocumentsAndActs />,
    handle: {
      permissions: UserPermissions.CommercialConsumersMeteringPointDocumentRead,
    },
  },
];
